import { render, staticRenderFns } from "./TablePixels.vue?vue&type=template&id=381e64b8&scoped=true&"
import script from "./TablePixels.vue?vue&type=script&lang=js&"
export * from "./TablePixels.vue?vue&type=script&lang=js&"
import style0 from "./TablePixels.vue?vue&type=style&index=0&id=381e64b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e64b8",
  null
  
)

export default component.exports